import React, { useState } from 'react';
import { ModalWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Button } from 'antd';
import { useProjectMemoList } from 'hooks';
import { ProjectMemoEditModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import moment from 'moment';

export interface ProjectMemoModalProps extends PopupProps {
    project_group_srl: number;
}

const ProjectMemoModal = ({ isOpen, onClose, project_group_srl }: ProjectMemoModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

   /* ======================================================
   * variables
   * ====================================================== */
   const { open } = usePopupManager(); 

  /* ======================================================
   * hooks
   * ====================================================== */
  const { memoInfo, memoInsert, memoUpdate } = useProjectMemoList({project_group_srl: project_group_srl}); 

   /* ======================================================
   * events
   * ====================================================== */
   const onMemoEditPopup = (id: number, memo: string, created_at: string) => {
    open(ProjectMemoEditModal, {
      id: id,
      project: memoInfo?.project || '',
      company: memoInfo?.company || '',
      created_at: created_at,
      memo: memo,
      onClose: (isOk, id, memo) => {
        if (isOk) {
            if (id === 0) {
                memoInsert({id, memo, project_group_srl})
            } else {
                memoUpdate({id, memo, project_group_srl})
            }
        }
      },
    }); 
   }

  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onClose} width={600} title={'참고사항'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                    <div>
                        <b>{memoInfo?.project} 대한 {memoInfo?.list? memoInfo?.list.length : 0} 건의 참고사항이 있습니다.</b>
                    </div>
                    <Button onClick={()=>onMemoEditPopup(0, '', moment().format("YYYY-MM-DD HH:mm"))}>등록</Button>
                </div>
                
                <div style={{maxHeight:"400px", overflowY:"auto", margin:"5px"}} >
                    {memoInfo?.list.map((item) => {
                        return (
                            <>  
                                <a onClick={()=>onMemoEditPopup(item.id, item.memo, item.created_at)}>[{item.created_at}] {item.who_update} 등록</a>
                                <hr />
                                <div style={{width:"100%"}}>
                                    <pre>{item.memo}</pre>
                                </div>
                                <hr />
                            </>
                        )
                    })}
                </div>
            </Space>     
        </ModalWrapper>  
    )    
};

export default React.memo(ProjectMemoModal);    